/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductOrderStatusSummary } from './ProductOrderStatusSummary';
import {
    ProductOrderStatusSummaryFromJSON,
    ProductOrderStatusSummaryFromJSONTyped,
    ProductOrderStatusSummaryToJSON,
    ProductOrderStatusSummaryToJSONTyped,
} from './ProductOrderStatusSummary';

/**
 * 
 * @export
 * @interface PagedAndSyncedResultProductOrderStatusSummary
 */
export interface PagedAndSyncedResultProductOrderStatusSummary {
    /**
     * 
     * @type {Array<ProductOrderStatusSummary>}
     * @memberof PagedAndSyncedResultProductOrderStatusSummary
     */
    content: Array<ProductOrderStatusSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultProductOrderStatusSummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultProductOrderStatusSummary
     */
    totalPages: number;
    /**
     * 
     * @type {Date}
     * @memberof PagedAndSyncedResultProductOrderStatusSummary
     */
    lastSyncedAt?: Date;
}

/**
 * Check if a given object implements the PagedAndSyncedResultProductOrderStatusSummary interface.
 */
export function instanceOfPagedAndSyncedResultProductOrderStatusSummary(value: object): value is PagedAndSyncedResultProductOrderStatusSummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedAndSyncedResultProductOrderStatusSummaryFromJSON(json: any): PagedAndSyncedResultProductOrderStatusSummary {
    return PagedAndSyncedResultProductOrderStatusSummaryFromJSONTyped(json, false);
}

export function PagedAndSyncedResultProductOrderStatusSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedAndSyncedResultProductOrderStatusSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(ProductOrderStatusSummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
    };
}

export function PagedAndSyncedResultProductOrderStatusSummaryToJSON(json: any): PagedAndSyncedResultProductOrderStatusSummary {
    return PagedAndSyncedResultProductOrderStatusSummaryToJSONTyped(json, false);
}

export function PagedAndSyncedResultProductOrderStatusSummaryToJSONTyped(value?: PagedAndSyncedResultProductOrderStatusSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(ProductOrderStatusSummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
        'lastSyncedAt': value['lastSyncedAt'] == null ? value['lastSyncedAt'] : value['lastSyncedAt'].toISOString(),
    };
}

